<div class="banner">
  <span class="banner-avatar">
    <mat-icon>folder</mat-icon>
  </span>

  <div class="banner-heading">
    <div class="banner-title">All Projects</div>
    <div class="banner-subtitle">
      Showing {{ filteredCount() }} of {{ total() }}
      {{ total() === 1 ? 'project' : 'projects' }}
      ·
      {{ organizationCount() }}
      {{ organizationCount() === 1 ? 'organization' : 'organizations' }}
    </div>
  </div>

  <div class="banner-actions">
    <div class="status-tiles">
      @for (tile of tiles; track tile.status) {
        <div class="status-tile" [class]="'tile--' + tile.status">
          <div class="status-count">{{ statusCounts()[tile.status] }}</div>
          <div class="status-label">{{ tile.label }}</div>
        </div>
      }
    </div>

    @if (showNewButton()) {
      <button mat-flat-button class="new-project" (click)="newProject.emit()">
        <mat-icon>add</mat-icon>
        New Project
      </button>
    }
  </div>

  @if (loading()) {
    <fb-loading-bar class="banner-loading" [rounded]="false" [height]="6" />
  }
</div>
